import React from 'react';
import { Avatar } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useAtom } from 'jotai';
import { userAtom } from '../../store/atoms';
import styles from './NotificationDropdown.module.scss';

interface NotificationDropdownProps {
  isMobile: boolean;
  onMobileDrawerClose?: () => void;
}

const NotificationDropdown: React.FC<NotificationDropdownProps> = ({ isMobile }) => {
  const [user] = useAtom(userAtom);
  const navigate = useNavigate();

  if (!user) return null;

  const hasImage = !!user?.thumbnailUrl;

  return (
    <Avatar
      className={`notification-avatar ${styles.userAvatar} ${hasImage ? styles.hasImage : ''}`}
      src={user?.thumbnailUrl}
      size={isMobile ? 30 : 42}
      style={{
        fontWeight: "500",
        fontSize: isMobile ? 12 : 16,
        cursor: "pointer",
      }}
      onClick={() => navigate('/settings')}
    >
      {!hasImage && (
        <>
          {user?.firstName?.[0]?.toUpperCase() || ''}{user?.lastName?.[0]?.toUpperCase() || ''}
        </>
      )}
    </Avatar>
  );
};

export default NotificationDropdown;
